<template>
  <base-modal>
    <div class="box">
      <h2 class="box-title is-size-6">
        <div class="flex-1 is-flex align-center justify-between">
          <div class="is-flex flex-column align-start">
            <span class="has-text-weight-bold">Scheduled {{ Naming.Job }} at {{ eventProps.extendedProps.site }} <span class="has-text-weight-light">({{ eventProps.extendedProps.job_type }})</span></span>
            <span class="has-text-weight-light"> for {{ eventProps.extendedProps.client }}</span>
          </div>
          <current-status :status="eventProps.extendedProps.current_status"/>
        </div>
      </h2>
      <div class="grid has-3-columns column-gap-1 row-gap-2">
        <div class="is-flex align-center is-2-columns">
          <avatar
            class="mr-1"
            :path="eventProps.extendedProps.technician_avatar"
            :name="eventProps.extendedProps.technician"/>
          <div>
            <p>Assigned to {{ overriddenTechnician || eventProps.extendedProps.technician }}</p>
            <p class="has-text-cool-blue-text-dark has-text-weight-medium">created {{ eventProps.extendedProps.created_at | date('L LTS') }}</p>
          </div>
        </div>
        <div class="grid has-1-columns gap-1">
          <summary-item
            title="Start Date"
            value-class="is-size-5 has-text-weight-light"
            :value="$options.filters.date(eventProps.start, 'L LTS')"/>
        </div>
        <div class="buttons is-2-columns">
          <action-button
            @click="goToJob"
            class="is-primary is-rounded"
            right-icon="chevron-right">
            Manage {{ Naming.RecurringJob }}
          </action-button>
          <action-button
            @click="overrideTechnician"
            class="is-cool-blue is-rounded">
            Change {{ Naming.Technician }}
          </action-button>
        </div>
      </div>
    </div>
  </base-modal>
</template>

<script>
import { scheduledJobTechnicianOverride } from '@/modals'

export default {

  props: {
    eventProps: {
      type: Object,
      required: true,
    }
  },

  data: () => ({
    overriddenTechnician: null,
  }),

  methods: {
    goToJob() {
      this.$close()
      this.$router.push({
        name: 'recurring-job-manager',
        params: {
          recurringJob: this.eventProps.extendedProps.recurring_job_id
        },
        query: {
          scheduled_job: this.eventProps.id
        }
      })
    },

    async overrideTechnician() {
      let overriddenTechnician = await scheduledJobTechnicianOverride({
        recurringJobId: this.eventProps.extendedProps.recurring_job_id,
        scheduledJobId: Number(this.eventProps.id)
      })

      if (overriddenTechnician) {
        this.overriddenTechnician = overriddenTechnician.full_name
        await this.$store.dispatch('job/loadJobCalendar')
        this.$toast.success(this.Convert('Technician changed successfully.'))
      }
    },
  }

}
</script>
